import { render, staticRenderFns } from "./settings-organization-keyword-auto-responses.vue?vue&type=template&id=574e70a7&scoped=true&"
import script from "./settings-organization-keyword-auto-responses.vue?vue&type=script&lang=js&"
export * from "./settings-organization-keyword-auto-responses.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization-keyword-auto-responses.vue?vue&type=style&index=0&id=574e70a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e70a7",
  null
  
)

export default component.exports